import React, { Component } from 'react'
import { connect } from 'react-redux'

import { selectors as UISelectors } from 'data/ui'
import { selectors as UserPreferencesSelectors } from 'data/userPreferences'

import BannerBase from './Base'
import { getCurrentUser } from '../../data/users/selectors'
import Timeago from 'components/Utils/Timeago'

function Section({ emoji = '', text, title }) {
  return (
    <div className="margin-right-normal font-weight-bold">
      <span title={title} className="padding-right-smaller">
        {emoji}
      </span>
      <span className="padding-right-smaller">{text}</span>
    </div>
  )
}

function getEmojiConnectivityStatus(connectivity) {
  switch (connectivity) {
    case UISelectors.CONNECTION_STATUSES_TYPE.CONNECTED:
      return '🔵'
    case UISelectors.CONNECTION_STATUSES_TYPE.DISCONNECTED:
      return '🔴'
    case UISelectors.CONNECTION_STATUSES_TYPE.RECONNECTING:
      return '⭕️'
    default:
      return '⚪️'
  }
}

class BannerDebug extends Component {
  render() {
    const {
      userEmail,
      userId,
      connectivityCollab,
      connectivityApp,
      connectivitySubscriptions,
      hasDebugFlag,
      subscriptionLastAt,
      subscriptionNotificationsCreatedAt,
    } = this.props

    if (!hasDebugFlag) {
      return false
    }

    return (
      <BannerBase className="flexbox-" small debug onClose={() => {}}>
        <div className="flexbox flexbox-align-center">
          <Section title={userId} emoji="🕵️‍" text={userEmail} />
          <Section
            emoji={getEmojiConnectivityStatus(connectivitySubscriptions)}
            title={connectivitySubscriptions}
            text="Subscriptions"
          />
          <Section
            emoji={getEmojiConnectivityStatus(connectivityCollab)}
            title={connectivityCollab}
            text="Collab"
          />
          <Section
            emoji={getEmojiConnectivityStatus(connectivityApp)}
            title={connectivityApp}
            text="App"
          />
          <Section
            emoji="⏬"
            title="Latest acknowledgment subscription received"
            text={
              subscriptionLastAt ? (
                <Timeago date={new Date(subscriptionLastAt).toISOString()} />
              ) : (
                '-'
              )
            }
          />
          <Section
            emoji="🔔"
            title="Latest notifications received via subscriptions"
            text={
              subscriptionNotificationsCreatedAt ? (
                <Timeago
                  date={new Date(
                    subscriptionNotificationsCreatedAt
                  ).toISOString()}
                />
              ) : (
                '-'
              )
            }
          />
        </div>
      </BannerBase>
    )
  }
}

export default connect(state => ({
  hasDebugFlag: UserPreferencesSelectors.hasFeatureFlag(state, 'debug'),
  // User info
  userId: getCurrentUser(state).id,
  userEmail: getCurrentUser(state).email,
  // Connectivity info
  connectivitySubscriptions: UISelectors.getConnectionStatus(state, 'graphql'),
  connectivityCollab: UISelectors.getConnectionStatus(state, 'collab'),
  connectivityApp: UISelectors.getConnectionStatus(state, 'navigator'),
  // Subscription info
  subscriptionLastAt: state.ui.subscriptionStatuses.get('lastAt'),
  subscriptionNotificationsCreatedAt: state.ui.subscriptionStatuses.get(
    'notificationsCreated'
  ),
}))(BannerDebug)
